import {
  DashboardSection,
  HuddleDay,
} from '@constants/Dashboard/dashboard.enums'
import { HUDDLE_DEFAULT_HIDDEN_SECTIONS } from '@constants/Dashboard/huddleSectionVisibility.constants'

export type HuddleSectionWaves = {
  todayForecast: number | null
  patients: number | null
  providerPerformance: number | null
  yesterdaysPerformance: number | null
  leaderboard: number | null
  events: number | null
  yesterdayActuals: number | null
  scheduleAdjustments: number | null
  yesterdayPerformance: number | null
  yesterdayProviderActuals: number | null
  tomorrowForecast: number | null
  tomorrowSchedule: number | null
  tomorrowGoals: number | null
}

function show(section: DashboardSection, hiddenSections: Set<string>): boolean {
  return (
    !HUDDLE_DEFAULT_HIDDEN_SECTIONS.has(section) && !hiddenSections.has(section)
  )
}

/** Day-scoped waves. Sections for the other huddle days stay null. */
export function buildHuddleSectionWaves(
  activeDayTab: HuddleDay,
  hiddenSections: Set<string>,
): HuddleSectionWaves {
  const today = activeDayTab === HuddleDay.Today
  const yesterday = activeDayTab === HuddleDay.Yesterday
  const tomorrow = activeDayTab === HuddleDay.Tomorrow
  const visible = (section: DashboardSection): boolean =>
    show(section, hiddenSections)
  return {
    todayForecast: today && visible(DashboardSection.TodaysForecast) ? 0 : null,
    patients: today && visible(DashboardSection.Patients) ? 0 : null,
    providerPerformance:
      today && visible(DashboardSection.ProviderPerformanceBreakdown)
        ? 1
        : null,
    yesterdaysPerformance:
      today && visible(DashboardSection.YesterdaysPerformance) ? 1 : null,
    leaderboard: today && visible(DashboardSection.Leaderboard) ? 1 : null,
    events: today && visible(DashboardSection.Events) ? 1 : null,
    yesterdayActuals:
      yesterday && visible(DashboardSection.YesterdaysActuals) ? 0 : null,
    scheduleAdjustments:
      yesterday && visible(DashboardSection.ScheduleAdjustments) ? 0 : null,
    yesterdayPerformance:
      yesterday && visible(DashboardSection.PerformanceVsGoal) ? 1 : null,
    yesterdayProviderActuals:
      yesterday && visible(DashboardSection.ProviderActualsYesterday)
        ? 1
        : null,
    tomorrowForecast:
      tomorrow && visible(DashboardSection.TomorrowsForecast) ? 0 : null,
    tomorrowSchedule:
      tomorrow && visible(DashboardSection.ScheduleAtAGlance) ? 0 : null,
    tomorrowGoals:
      tomorrow && visible(DashboardSection.GoalsForTomorrow) ? 1 : null,
  }
}
